import script from "./UCCardGH.vue?vue&type=script&setup=true&lang=js"
export * from "./UCCardGH.vue?vue&type=script&setup=true&lang=js"

import "./UCCardGH.vue?vue&type=style&index=0&id=a54d7016&lang=scss"

const __exports__ = script;

export default __exports__